// Modelo legacy, puede darse algun caso en el que el itemType todavia llegue en formato legacy
export enum ItemTypeLegacy {
    CLOTHES = 0,
    TEMPE = 1,
    PERFUMERIA = 2,
    OYSHOLENCERIA = 3,
    MENAJEZARAHOME = 4,
    TARJETAS = 5,
}

// Modelo IOP del ItemType
export enum ItemType {
    UNKNOWN = 0,
    PRODUCT = 1,
    PHYSICALGIFTCARD = 2,
    VIRTUALGIFTCARD = 3,
    GIFT = 4,
    GIFTRECEIPT = 4,
    OTHER = 5,
    GIFTPACKING = 6,
    CUSTOMIZATION = 7,
}

export interface ItemProductCartButtonActions {
    title: string;
    event: string;
    category: string;
    image: string;
    changeWithStock: boolean;
}

export const OPTIONS_CART: ItemProductCartButtonActions[] = [
    {
        title: 'dev.general.delete',
        event: 'deleteItemShopcart',
        category: 'actions',
        image: 'delete',
        changeWithStock: true,
    },
];

export const OPTIONS_CART_WISH: ItemProductCartButtonActions[] = [
    {
        title: 'dev.cart.addToWishlist',
        event: 'addItemWishlist',
        category: 'common',
        image: 'bookmark',
        changeWithStock: true,
    },
    {
        title: 'dev.general.delete',
        event: 'deleteItemShopcart',
        category: 'actions',
        image: 'delete',
        changeWithStock: true,
    },
];

export const OPTIONS_CART_BUYLATER: ItemProductCartButtonActions[] = [
    {
        title: 'dev.cart.buy.later',
        event: 'addItemWishlist',
        category: 'common',
        image: 'bookmark',
        changeWithStock: true,
    },
    {
        title: 'dev.general.delete',
        event: 'deleteItemShopcart',
        category: 'actions',
        image: 'delete',
        changeWithStock: true,
    },
];

export const OPTIONS_WISH: ItemProductCartButtonActions[] = [
    {
        title: 'dev.product.addToShopCart',
        event: 'addToBag',
        category: 'shopping-bag',
        image: 'shopping-bag',
        changeWithStock: true,
    },
    {
        title: 'dev.general.delete',
        event: 'deleteItem',
        category: 'actions',
        image: 'delete',
        changeWithStock: false,
    },
];

export const OPTIONS_DEFAULT: ItemProductCartButtonActions[] = [];
